<template>
    <!-- <svg :x="box.x" :y="box.y" :width="box.width" :height="box.height">
        <rect :x="0" :y="0" :width="box.width" :height="box.height" fill="transparent" stroke="grey" stroke-width="0.5"></rect>
        <text :x="(0 + box.width)/2" :y="(0 + box.height)/2" text-anchor="middle" contenteditable>Hello</text>
    </svg> -->
    <div class="text-field center d-flex align-center" :style="textStyle">
        <span style="width: 100%">{{ box.properties.text }}</span>
    </div>
</template>
<script lang="ts">
import { Box, Layout, TextFieldBox } from "../models";
import BoxPopupMenu from "../BoxPopupMenu.vue";
import { Prop } from "vue-facing-decorator";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component({
    components: {
        BoxPopupMenu,
    },
})
export class Title extends Vue {
    @Prop() box: TextFieldBox;

    get textStyle() {
        if (!this.box.selectedTextStyle) return this.box.selectedTextStyle;
        const objCopy = { ...this.box.selectedTextStyle };
        if (objCopy.italic === true) {
            objCopy.fontStyle = "italic";
        }
        objCopy.fontSize = objCopy.fontSize + "pt";
        objCopy.fontWeight = objCopy.bold ? "bold" : null;
        return objCopy;
    }
}

export default toNative(Title);
</script>
<style lang="css" scoped>
.text-field {
    height: 100%;
    width: 100%;
}

.text-field.center,
.text-field.middle,
.text-field.text-center,
.text-field.text-middle {
    text-align: center;
}

.text-field.start,
.text-field.text-start {
    text-align: start;
}

.text-field.end,
.text-field.text-end {
    text-align: end;
}
</style>
